import 'css-chunksrc/client/pages/unExpectedErrorPage/styles.scss';export default {
  "unExpectedErrorPage": "_unExpectedErrorPage_1wfp5_1",
  "page": "_page_1wfp5_8",
  "main": "_main_1wfp5_20",
  "icon": "_icon_1wfp5_35",
  "col": "_col_1wfp5_39",
  "title": "_title_1wfp5_46",
  "message": "_message_1wfp5_51",
  "buttons": "_buttons_1wfp5_56"
};